import { IMtList } from '@/api/mt/type'

interface ITaskStateMap {
  label: string
  icon: string
}

export const taskStateMap: Record<IMtList.ETaskState, ITaskStateMap> = {
  [IMtList.ETaskState.Init]: {
    label: '待翻译',
    icon: 'icon_task_waiting'
  },
  [IMtList.ETaskState.Loading]: {
    label: '待翻译',
    icon: 'icon_task_waiting'
  },
  [IMtList.ETaskState.Working]: {
    label: '翻译中',
    icon: 'icon_task_working'
  },
  [IMtList.ETaskState.Done]: {
    label: '翻译完成',
    icon: 'icon_task_success'

  },
  [IMtList.ETaskState.Fail]: {
    label: '翻译失败',
    icon: 'icon_task_fail'
  },
}

export const languageMap: Record<string, string> = {
  cn: '中文',
  en: '英文',
  ko: '韩语',
}

export type tabNames = 'txtMT' | 'fileMT' | 'listMT'
export interface ILeftTab {
  name: tabNames,
  label: string,
  icon: string
}

